import { createSettingDefaultAction } from "../services/ServiceHelper";
import { forgotPassword } from "../services/LoginService";
import { createActionThunk } from "redux-thunk-actions";
import {
  FORGOT_PASSWORD_SET_DEFAULT,
  FORGOT_PASSWORD_SUBMIT,
  ON_CHANGE_FORGOT_PASSWORD_FORM,
} from "./constant";

const setDefaultState = createSettingDefaultAction(FORGOT_PASSWORD_SET_DEFAULT);
const forgotPasswordSubmit = createActionThunk(
  FORGOT_PASSWORD_SUBMIT,
  (email) => forgotPassword(email)
);

const onChangeForm = (e) => {
  return (dispatch) => {
    dispatch({
      type: ON_CHANGE_FORGOT_PASSWORD_FORM,
      value: e.target.value,
    });
  };
};

export default { setDefaultState, forgotPasswordSubmit, onChangeForm };



// WEBPACK FOOTER //
// ./src/actions/forgotPasswordActions.js